<button [matMenuTriggerFor]="menu" mat-icon-button>
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <ng-container *ngFor="let action of pageActions">
    <button (click)="action.options.callback($event)" *ngIf="!action.options.hidden" [disabled]="action.options.disabled" [ngClass]="action.options.type"
            mat-menu-item>
      <mat-icon>{{action.options.icon}}</mat-icon>
      <span *ngIf="action.options.translationString">{{action.options.translationString | translate}}</span>
      <span *ngIf="!action.options.translationString">{{action.options.title}}</span>
    </button>
  </ng-container>
</mat-menu>


